import {Alert as MUIAlert, ListItemIcon as MUIListItemIcon} from '@mui/material'
import {styled} from 'styled-components'

import theme from '../../styles/theme'

export const Alert = styled(MUIAlert)`
  align-items: center;
  margin-bottom: 22px;
`

export const ListItemIcon = styled(MUIListItemIcon)`
  min-width: 0 !important;
  margin-right: ${theme.spacing(2)};
`
